export default function advancedActivities({ next, router }) {
    if (localStorage.getItem('activities-framework-type') !== 'advanced') {
        return router.push({ name: 'unauthorised' });
    }

    return next();
}
